export default __webpack_public_path__ + "static/media/FleetScreenShot.5ac346f6.png";